<template>
  <div
    style="overflow: hidden"
    v-if="visible"
  >
    <force-landscape
      class="mask"
      style="z-index: 5"
      :forceLandscape="true"
    >
      <template>
        <!-- 退出按钮 -->
        <div class="font1">
          <!-- 分享和退出 -->
          <div class="right-icons">
            <div
              class="share-icon"
              @click="share"
            ></div>
            <div
              class="exit-icon"
              @click="exit"
            ></div>
          </div>

          <!-- 成功 -->
          <div v-if="config.status == 1">
            <!-- <web-view :src="url" @message="getMessage"></web-view> -->
            <div style="text-align: center; height: 100%; margin-top: 6%">
              <div
                style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 2vmin;
              "
              >
                <div class="leftarrow"></div>
                <div class="title">{{ config.title }}</div>
                <div class="rightarrow"></div>
              </div>

              <div class="bg">
                <div class="gift-icon"></div>
                <div class="desc-txt">{{ config.giftDesc }}</div>
              </div>
              <div
                @click="back()"
                class="successBtn"
                v-if="config.continue"
              >{{ config.continue }}</div>
            </div>
          </div>
          <!-- 失败 -->
          <div
            v-if="config.status == 2"
            class="fail-container"
          >
            <div style="color: #ffffff">{{ config.title }}</div>
            <div class="game-icon"></div>
            <div class="ButtonList">
              <div
                @click="back()"
                class="ButtonText2"
                v-if="config.continue"
              >{{ config.continue }}</div>
              <div
                @click="exitgame()"
                class="ButtonText"
                v-if="config.exit"
              >{{ config.exit }}</div>
            </div>
          </div>
          <!-- 绑定账号成功 -->
          <div v-if="config.status == 4">
            <div style="text-align: center; height: 100%; margin-top: 10%">
              <div class="bg">
                <div
                  style="color:#ffffff; line-height: 8vmin;"
                  v-html="config.content"
                ></div>
              </div>
              <div
                @click="back()"
                class="successBtn"
                v-if="config.continue"
              >{{ config.continue }}</div>
            </div>
          </div>
        </div>
      </template>
    </force-landscape>
  </div>
</template>
<script>
import ForceLandscape from "../../../components/layout/ForceLandscape.vue";
import { copyText } from "@/util/cloudgame/game-service";
import { postApiRtt } from "@/util/performance";

export default {
  components: {
    ForceLandscape,
  },

  data() {
    return {
      visible: false,
      needForceLandscape: false,
      loaded: false,
      type: 1, // 1残局 2兵海挑战
      modalbefore: {},
      config: {},
      status: 0, // 1 胜利，2 失败，3 大成功
    };
  },

  methods: {
    getMessage(value) {
      console.log(value);
    },

    show() {
      this.visible = true;
    },

    back() {
      this.visible = false;
      // this.modalbefore.show();
    },

    exitgame() {
      // window.location.reload();
      // restartGame();
      // CloudGame.pureQuitGame();
      // window.location.replace("/hok/home");
      // router.replace(`/hok/home`);
      this.visible = false;
    },
    share() {
      copyText(window.location.href, this);
      postApiRtt("share_click");
    },
    exit() {
      window.location.href = `https://www.honorofkings.com/`;
      postApiRtt("exit_click");
    },
  },
};
</script>
<style lang="less" scoped>
.font1 {
  font-family: "Radikal Medium";
  height: 100%;
}
.title {
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
  display: inline-block;
  margin: 0 2vmin;
  text-shadow: 0px 0px 20px #172446, 0px 0px 5px #ffffff, 0px 0px 5px #172446,
    0px 0px 10px #172446;
}

.bg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-image: url("../../../assets/hok/dialog_bg.png");
  background-size: 100% 100%;
  width: 100%;
  height: 45vmin;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.ButtonList {
  // text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 2vmin;
}

.ButtonText {
  color: white;
  display: inline-block;
  margin: 0 2vmin;
  min-width: 35vmin;
  font-size: 15px;
  padding: 2vmin;
  background-image: url(../../../assets/hok/cancel-btn.png);
  background-size: 100% 100%;
  text-align: center;
}

.ButtonText2 {
  color: #ffffff;
  display: inline-block;
  margin: 0 2vmin;
  min-width: 35vmin;
  font-size: 15px;
  padding: 2vmin;
  background-image: url(../../../assets/hok/confirm-btn.png);
  background-size: 100% 100%;
  text-align: center;
}

.successBtn {
  position: absolute;
  color: #ffffff;
  display: inline-block;
  min-width: 35vmin;
  font-size: 15px;
  padding: 2vmin;
  background-image: url(../../../assets/hok/cancel-btn.png);
  background-size: 100% 100%;
  text-align: center;
  left: 50%;
  transform: translate(-50%, 0%);
  bottom: 10vmin;
}

.leftarrow {
  background-image: url(../../../assets/hok/huawenzuo.png);
  background-size: 100% 100%;
  display: inline-block;
  width: 22vmin;
  height: 4vmin;
}

.rightarrow {
  background-image: url(../../../assets/hok/huawenzuo.png);
  transform: rotate(180deg);
  background-size: 100% 100%;
  display: inline-block;
  width: 22vmin;
  height: 4vmin;
}

.exitimg {
  background-image: url(../../../assets/hok/fanhui.png);
  background-size: 100% 100%;
  display: inline-block;
  width: 14vmin;
  height: 8vmin;
}

.exitbutton {
  position: fixed;
  left: 4vmin;
  top: 4vmin;
}

.timetext {
  font-size: 24vmin;
  color: rgb(255, 241, 195);
  margin-top: 10vmin;
}
.mask {
  background: linear-gradient(to top, #080f19, #172446);
}
.game-icon {
  background-image: url("../../../assets/hok/app_icon.png");
  background-size: 100% 100%;
  width: 40vmin;
  height: 40vmin;
  border-radius: 5vmin;
}
.fail-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  div {
    margin: 2vmin;
  }
}
.gift-icon {
  width: 18vmin;
  height: 18vmin;
  margin: 2vmin;
  background-image: url("../../../assets/hok/gift_icon.png");
  background-size: 100% 100%;
}
.desc-txt {
  font-size: 3vmin;
  color: #97b4e0;
  font-weight: bold;
}
.right-icons {
  position: absolute;
  top: 3vmin;
  right: 3vmin;
  display: flex;
}
.share-icon {
  background-image: url("../../../assets/hok/share-icon.png");
  background-size: contain;
  width: 8vmin;
  height: 8vmin;
  margin: 2vmin;
}
.exit-icon {
  background-image: url("../../../assets/hok/exit-icon.png");
  background-size: contain;
  width: 8vmin;
  height: 8vmin;
  margin: 2vmin;
}
</style>
